export default class OrganizationDeviceTree {
    constructor (
        id,
        level,
        name
    ) {
        this.id = id
        this.level = level
        this.name = name
        this.type = 'Device'
        this.parent = null
        this.items = []
        this.isChanged = false
        this.isExpanded = false
    }

    setParent (parent) {
        this.parent = parent
    }
}
